import React from 'react';

const ScoreBar = ({ label, score, active = true, className = '' }) => {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <span className="text-sm font-medium text-gray-600 dark:text-gray-300 w-28 shrink-0 truncate">
        {label}
      </span>
      <div className="flex-1 h-1.5 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden">
        {active ? (
          <div
            className="h-full rounded-full transition-all duration-700 ease-out bg-primary-500 dark:bg-primary-400"
            style={{ width: `${Math.min(score, 100)}%` }}
          />
        ) : null}
      </div>
      <span className="text-sm font-medium tabular-nums w-7 text-right text-gray-600 dark:text-gray-300">
        {active ? Math.round(score) : '—'}
      </span>
    </div>
  );
};

export default ScoreBar;
